import { ViewerApi } from "./ViewerApi";
import getAppConfig from "./config/appConfig";
import { version } from "../package.json";

import {
  RendererTypes,
  ENVIRONMENTS,
  Link,
  Media,
  Image,
  Video,
  Audio,
  ViewerConfig,
  Route,
  Theme,
  Ancestry,
  ConfigurationField,
  CoursewareStructure,
  Deployment,
  Pathway,
  Screen,
  IAnnotation,
  IAnnotationPopoverData,
  ScrollData,
  PageData,
} from "@bronte/viewer/src/main";
import { ThemeVariant, ThemeVariants, ThemeOptions } from "./shared/types";

export { ViewerApi, getAppConfig, RendererTypes, ENVIRONMENTS };
export type {
  ViewerConfig,
  Route,
  Link,
  Media,
  Image,
  Video,
  Audio,
  Screen,
  Theme,
  Ancestry,
  ThemeVariant,
  ThemeVariants,
  ThemeOptions,
  ConfigurationField,
  CoursewareStructure,
  Deployment,
  Pathway,
  IAnnotation,
  IAnnotationPopoverData,
  ScrollData,
  PageData,
};

console.log(`Bronte Viewer Library Version  : ${version}`);
